export class COLORS {
  static BLACK = '#000000';
  static WHITE = '#FFFFFF';
  // Red
  // static BACKGROUND = '#f7f3f0';
  // static PRIMARY = '#c74817';
  // static SECONDARY = '#DF7411';

  // Yellow
  // static BACKGROUND = '#F7F7F0';
  // static PRIMARY = '#FFC920';
  // static SECONDARY = '#000000';

  // Blue
  static BACKGROUND = '#F4F5FF';
  static PRIMARY = '#17224F';
  static SECONDARY = '#4DBCC9';
  static ACCENT = '#F7C548';

  static TEXT = 'rgba(30,30,30,0.87)';
  static SUCCESS = '#25D425';
  static ERROR = '#E02B1A';
  static WARNING = '#EEBA3F';
}
